<template>
	<div class="container pt-6 pb-10">
		<div class="flex justify-between items-center py-2 mb-4">
			<h1 class="page-title-secondary">Adauga oferta productie</h1>
		</div>
		<v-form v-model="addOfferForm">
			<div class="grid grid-cols-2 gap-8">
				<v-card class="rounded-lg py-4 px-6">
					<h2 class="text-lg font-medium mb-4">Detalii oferta</h2>
					<div class="grid grid-cols-3 gap-4">
						<v-menu v-model="datepickerMenu" class="col-span-1" :close-on-content-click="false"
							transition="scale-transition" :nudge-right="40" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="computedDateFormatted" label="Data oferta"
									prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
									outlined></v-text-field>
							</template>
							<v-date-picker v-model="oferta.today" no-title
								@input="datepickerMenu = false"></v-date-picker>
						</v-menu>
						<v-select v-model="oferta.tip_lucrare" class="col-span-1" :items="typeItems" label="Tip lucrare"
							outlined></v-select>
						<v-select v-model="oferta.country" class="col-span-1" :items="countryItems" label="Tara"
							outlined></v-select>
						<v-text-field v-model="oferta.denumire" class="col-span-2" label="Denumire lucrare"
							outlined></v-text-field>
					</div>
				</v-card>

				<v-card class="rounded-lg py-4 px-6">
					<h2 class="text-lg font-medium mb-4">Detalii client</h2>
					<div>
						<v-autocomplete v-model="client" :loading="loading" :items="clienti" return-object flat
							hide-details label="Alege client" outlined></v-autocomplete>
					</div>
					<v-dialog v-model="addClientModal" max-width="600px">
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="teal" text class="uppercase my-4" dark v-bind="attrs" v-on="on">
								Adauga client nou
							</v-btn>
						</template>
						<AddClient @clientName="client.text = $event" @clientSelected="client = $event"
							@closeModal="addClientModal = false" />
					</v-dialog>
					<div>
						<v-autocomplete v-model="county" :loading="loadingCounties" :items="counties" item-text="name"
							item-value="id_county" :label="`Alege ${oferta.country == 'ro' ? 'judet' : 'regiune'}`"
							hide-details outlined></v-autocomplete>
					</div>

					<v-progress-linear v-if="loadingCheckOferteGarduri" indeterminate
						color="primary"></v-progress-linear>

					<v-alert v-if="oferte_check_productie_garduri.length" type="warning" outlined>
						<div class="flex flex-row justify-between">
							<p>Clientul are oferte generate</p>
							<v-btn text @click="visibleCheckOffers = !visibleCheckOffers">vezi detalii</v-btn>
						</div>
						<v-simple-table v-if="visibleCheckOffers">
							<template v-slot:default>
								<tbody>
									<tr v-for="item in oferte_check_productie_garduri" :key="item.id_oferta">
										<td>{{ item.id_oferta }}</td>
										<td>{{ item.data | formatDate }}</td>
										<td>{{ item.username }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-alert>
				</v-card>
			</div>
		</v-form>

		<div class="flex flex-row justify-end gap-4 mt-4">
			<v-btn color="blue-grey" class="white-text uppercase" x-large @click="cancelAddOffer">Anuleaza</v-btn>
			<v-btn color="teal" class="white-text uppercase" x-large :disabled="loadingCheckOferteGarduri"
				@click="addOfertaProductie">Salveaza</v-btn>
		</div>

		<!-- <pre>{{ client }}</pre> -->
		<!-- <pre>{{ $data }}</pre> -->
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import AddClient from "@/components/Clients/AddClient";
import { isExportOnly } from "@/utils";

export default {
	name: "AddOfertaProductie",
	components: {
		AddClient,
	},
	data() {
		return {
			addOfferForm: false,
			addClientModal: false,
			loading: false,
			datepickerMenu: false,
			visibleCheckOffers: false,
			client: {
				value: "",
				text: "",
			},
			county: null,
			oferta: {
				today: moment().format("YYYY-MM-DD"),
				tip_lucrare: "gard",
				denumire: "gard din aluminiu vopsit electrostatic",
				moneda: "ron",
				country: "ro",
			},
			details: {
				t_executie: "60",
				garantie: "2 ani",
				c_plata: 50,
				detalii: "",
			},
		};
	},
	computed: {
		...mapState(["oferte_check_productie_garduri", "loadingCheckOferteGarduri"]),
		...mapState('zones', ["loadingCounties", "counties"]),
		clienti() {
			return this.$store.getters.selectClienti;
		},
		returnClientId() {
			return this.$store.getters.returnClientId;
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		termen() {
			let date = moment(this.oferta.today, "YYYY-MM-DD");
			let nr = this.oferta.t_plata;
			let data_plata = date.add(nr, "days").format("YYYY-MM-DD");
			return data_plata;
		},
		computedDateFormatted() {
			return this.formatDate(this.oferta.today)
		},
		typeItems() {
			const types = [
				{
					text: "Gard aluminiu",
					value: "gard"
				}
			]
			if (['admin', 'superuser'].includes(this.user.rol)) {
				const general = {
					text: "General",
					value: "general"
				}
				types.push(general)
			}
			return types
		},
		countryItems() {
			const countries = [
				{
					text: "Romania",
					value: "ro"
				}
			]
			if (['admin', 'superuser', 'user'].includes(this.user.rol) || this.user.email_user == 'alexandru.pietrariu@cuprolli.ro') {
				const austria = {
					text: "Austria",
					value: "at"
				}
				countries.push(austria)
				const france = {
					text: "Franta",
					value: "fr"
				}
				countries.push(france)
				const germany = {
					text: "Germania",
					value: "de"
				}
				countries.push(germany)
				const hungary = {
					text: "Ungaria",
					value: "hu"
				}
				countries.push(hungary)
			}
			// export agents make only EU offers
			return isExportOnly(this.user) ? countries.filter((c) => c.value !== "ro") : countries
		}
	},
	watch: {
		"oferta.tip_lucrare"(value) {
			if (value == "gard") {
				this.oferta.denumire = this.returnDefaultDenumire()
			} else {
				this.oferta.denumire = "";
			}
		},
		"oferta.country"(newVal) {
			if (this.oferta.tip_lucrare == "gard") {
				this.oferta.denumire = this.returnDefaultDenumire()
				this.fetchCounties(newVal)
			} else {
				this.oferta.denumire = "";
			}
		},
		returnClientId: function (newVal) {
			this.client.value = newVal.toString();
		},
		"client.value"(newVal, oldVal) {
			if (newVal != oldVal) {
				this.resetCheckOffersItems()
				this.$store.dispatch("checkProductionOffersExist", newVal);
			}
		}
	},
	methods: {
		...mapActions('zones', ["fetchCounties"]),
		resetCheckOffersItems() {
			this.$store.commit("loadOferteCheckProductieGarduri", [])
		},
		cancelAddOffer() {
			this.resetCheckOffersItems()
			this.$router.push({ path: '/oferte-productie' })
		},
		returnDefaultDenumire() {
			switch (this.oferta.country) {
				case 'ro':
					return "gard din aluminiu vopsit electrostatic"
				case 'at':
					return "Pulverbeschichteter Aluminiumzaun"
				case 'de':
					return "Pulverbeschichteter Aluminiumzaun"
				case 'fr':
					return "Clôture en aluminium avec revêtement en poudre électrostatique"
				case 'hu':
					return "Elektrosztatikusan porszórt alumínium kerítés"
				default:
					return
			}
		},
		formatDate(date) {
			if (!date) return null
			const [year, month, day] = date.split('-')
			return `${day}/${month}/${year}`
		},
		formatWarrantyString(warranty) {
			if (this.oferta.country == 'at' || this.oferta.country == 'de') {
				return warranty.replace("ani", "Jahre").replace("an", "Jahr");
			} else if (this.oferta.country == 'fr') {
				return warranty.replace("ani", "Ans").replace("an", "An");

			} else if (this.oferta.country == 'hu') {
				return warranty.replace("ani", "Év").replace("an", "Év");
			}
			return warranty
		},
		addOfertaProductie() {
			if (
				!this.client.value ||
				!this.oferta.today ||
				!this.oferta.moneda ||
				!this.oferta.tip_lucrare
			) {
				M.toast({
					html: "Completati toate campurile!",
				});
			} else if (this.oferta.country == 'ro' && !this.county) {
				M.toast({
					html: "Selectati judetul!",
				});
			} else {
				let newOfertaProductie = {
					client_id: this.client.value,
					data: this.oferta.today,
					tip_lucrare: this.oferta.tip_lucrare,
					country: this.oferta.country,
					county_id: this.county,
					denumire: this.oferta.denumire,
					moneda: this.oferta.moneda,
					color: this.oferta.tip_lucrare == "gard" ? "client nehotarat" : null,
					t_executie:
						this.oferta.tip_lucrare == "gard" ? this.details.t_executie : "",
					garantie:
						this.oferta.tip_lucrare == "gard" ? this.formatWarrantyString(this.details.garantie) : "",
					c_plata:
						this.oferta.tip_lucrare == "gard" ? this.details.c_plata : "",
					detalii:
						this.oferta.tip_lucrare == "gard" ? this.details.detalii : "",
					user_id: this.user.id_user,
				};

				this.$store.dispatch("addOfertaProductie", newOfertaProductie);
				this.resetCheckOffersItems()
			}
		},
		fetchClienti() {
			this.$store.dispatch("fetchClienti");
		},
	},
	created() {
		this.fetchClienti();
		// the form starts on Romania, which export agents don't get
		if (isExportOnly(this.user) && this.oferta.country === "ro" && this.countryItems.length) {
			this.oferta.country = this.countryItems[0].value;
		}
		this.fetchCounties(this.oferta.country);
	},
	unmounted() {
		console.log('unmount')
		this.$store.commit("loadOferteCheckProductieGarduri", [])
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
